import { Select } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Thaiflag from "../assets/thaiflag.png";
import Ukflag from "../assets/ukflag.png";
import Bahasa from "../assets/bahasa.png";

const { Option } = Select;

const LanugageSelector = ({ langMenu, defaultLang }) => {
  const dispatch = useDispatch();
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const handleChange = (value) => {
    if (value == "en") {
      dispatch({
        type: "ENGLISH_LANGUAGE",
        payload: value,
      });
    } else if (value === "th") {
      dispatch({
        type: "THAI_LANGUAGE",
        payload: value,
      });
    } else if (value === "bi") {
      dispatch({
        type: "BAHASA_LANGUAGE",
        payload: value,
      });
    }
    // setLang(value);
    // localStorage.setItem("lng", value);
  };

  return (
    <div>
      <Select
        defaultValue={defaultLang ? defaultLang : "en"}
        value={lang}
        onChange={handleChange}
      >
        {[...(langMenu ? langMenu : ["en", "th"])]?.map((item) => {
          return (
            <Option value={item}>
              <img
                src={item === "en" ? Ukflag : item === "th" ? Thaiflag : Bahasa}
                style={{
                  width: 20,
                }}
              />
            </Option>
          );
        })}
        {/* <Option value="en">
          <img
            src={Ukflag}
            style={{
              width: 20,
            }}
          />
        </Option>
        <Option value="th">
          <img
            src={Thaiflag}
            style={{
              width: 20,
            }}
          />
        </Option> */}
      </Select>
    </div>
  );
};

export default LanugageSelector;
